import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/seo-articles';

export default function ArticleList() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-4">
              SEO Resources
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              LitBuy Spreadsheet Guides &amp; Articles
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
              Expert-written SEO articles covering everything from beginner basics to advanced LitBuy Spreadsheet techniques
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {seoArticles.map((article) => (
              <Link
                key={article.slug}
                to={`/article/${article.slug}`}
                className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-200">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 text-xs font-medium bg-white/90 text-foreground-800 rounded-full">
                      {article.readTime}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {article.description}
                  </p>
                  <div className="mt-3 flex items-center justify-between">
                    <span className="text-xs text-foreground-400">LitBuy Editorial Team</span>
                    <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                      Read Article
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-arrow-right-line text-sm"></i>
                      </span>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {/* View all link */}
          <div className="mt-8 text-center">
            <Link
              to="/shopping-guide"
              className="inline-flex items-center gap-2 bg-primary-500 text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              View All Shopping Guides
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}